import { render } from "./ShortPollResults.vue?vue&type=template&id=0be877ee"
import script from "./ShortPollResults.vue?vue&type=script&lang=js"
export * from "./ShortPollResults.vue?vue&type=script&lang=js"

import "./ShortPollResults.vue?vue&type=style&index=0&id=0be877ee&lang=stylus"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__